import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import DynamicBackground from '../../components/DynamicBackground/index'


const NewsletterSite = () => {
    const { id } = useParams(); // Extrahiert die UUID aus der URL
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            email,
            list_uuids: [id]
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        try {
            const response = await fetch("https://listmonk.cloudtal.de/api/public/subscription", requestOptions);

            if (response.ok) {
                const result = await response.json();

                if (result?.data?.has_optin === false) {
                    setErrorMessage("This email is already subscribed.");
                    setSuccessMessage("");
                } else {
                    setSuccessMessage("You have successfully subscribed to the newsletter!");
                    setErrorMessage("");
                }
            } else {
                const result = await response.text();
                setErrorMessage(result || "An error occurred.");
                setSuccessMessage("");
            }
        } catch (error) {
            setErrorMessage("An error occurred while subscribing.");
            setSuccessMessage("");
        }
    };

    return (
        // main als Container mit position: relative, damit der absolut positionierte Hintergrund innerhalb des main-Bereichs bleibt
        <main className="relative flex flex-col items-center justify-center bg-zinc-900 text-zinc-200 min-h-screen">
            {/* Dynamischer Hintergrund, der den gesamten main ausfüllt */}
            <DynamicBackground />
            {/* Inhalt mit höherem z-Index, sodass er über dem Hintergrund liegt */}
            <section className="w-full py-12 md:py-24 lg:py-32 relative z-10">
                <div className="container px-4 mx-auto">
                    <div className="flex flex-col items-center text-center space-y-8">
                        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl lg:text-6xl">
                            Newsletter Anmeldung
                        </h1>
                        <p className="max-w-2xl text-lg">
                            Wir arbeiten intensiv an der Beta von Cloudtal und suchen noch Tester! Unser erstes Produkt: <strong>PostgreSQL Serverless</strong>. Im weiteren Verlauf folgen dann noch <strong>Keycloak</strong> und <strong>Redis</strong> – alles Serverless und Dedicated.
                            Melde dich an und bleibe immer auf dem neuesten Stand!
                        </p>
                        <form onSubmit={handleSubmit} className="w-full max-w-md flex flex-col space-y-4">
                            <input
                                type="email"
                                placeholder="Deine E-Mail Adresse"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="px-4 py-2 rounded bg-zinc-800 border border-zinc-700 focus:outline-none focus:border-green-400"
                            />
                            <button
                                type="submit"
                                className="px-4 py-2 rounded bg-green-500 hover:bg-green-600 transition-colors"
                            >
                                Anmelden
                            </button>
                        </form>
                        {successMessage && <p className="mt-4 text-green-400">{successMessage}</p>}
                        {errorMessage && <p className="mt-4 text-red-400">{errorMessage}</p>}
                    </div>
                </div>
            </section>
        </main>
    );
};

export default NewsletterSite;
